var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Input } from "./Input";
import { validateEmailSync, validateEmailAsync, createValidator } from "./validation";
import { EmailUse } from "./admin-gql";
import { SelectEmailUse } from "./SelectEmailUse";
import { debounceTimeInMs } from "./constants";
import { Link } from "react-router-dom";
import i18next from "i18next";
import { Trans } from "react-i18next";
var EmailControl = /** @class */ (function (_super) {
    __extends(EmailControl, _super);
    function EmailControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validator = createValidator(debounceTimeInMs);
        _this.checkboxId = Math.random().toString();
        _this.handleValueChanged = function (val) {
            _this.props.onChange(__assign(__assign({}, _this.props.email), { value: val || "" }), _this.props.email);
        };
        return _this;
    }
    EmailControl.prototype.render = function () {
        var _this = this;
        var email = this.props.email;
        var readonly = this.props.readonly;
        return (React.createElement("div", { className: this.props.className },
            React.createElement("div", { className: "form-row", style: { marginBottom: 7 } },
                React.createElement("div", { className: "col-6 form-group" },
                    React.createElement(Input, { forceShowValidationError: this.props.forceShowValidationErrors, onChange: this.handleValueChanged, loading: !!email.validationPromise, readonly: !email.new || readonly, validationErrorMessage: email.validationError && email.validationError.type === "AlreadyExists" ? (React.createElement(React.Fragment, null,
                            React.createElement(Trans, { i18nKey: "cc.email.control.thereIsAlreadyAccountWithEmailAddress" },
                                "Det finns redan ",
                                React.createElement(Link, { to: this.props.onGenerateLinkToUser(email.validationError.userId) }, "ett konto"),
                                "med e-postadressen."))) : email.validationError && email.validationError.type === "FailedToValidate" ? (React.createElement(React.Fragment, null, i18next.t("cc.email.control.failedValidateEmail"))) : email.validationError && email.validationError.type === "Message" ? (React.createElement(React.Fragment, null, email.validationError.message)) : email.validationError ? (React.createElement(React.Fragment, null, i18next.t("cc.email.control.somethingWentWrong"))) : null, value: email.value, disabled: this.props.disabled, placeholder: i18next.t("cc.email.control.email"), autoFocus: this.props.autoFocus }),
                    React.createElement("div", { className: "form-check mt-2" },
                        React.createElement("input", { type: "checkbox", className: "form-check-input", id: this.checkboxId, checked: email.confirmed, readOnly: readonly, disabled: this.props.disabled || readonly, onChange: function (ev) {
                                return _this.props.onChange(__assign(__assign({}, email), { confirmed: ev.target.checked }), email);
                            } }),
                        React.createElement("label", { className: "form-check-label", htmlFor: this.checkboxId }, i18next.t("cc.email.control.emailVerified")))),
                React.createElement("div", { className: "col-6" },
                    React.createElement(SelectEmailUse, { readonly: readonly, use: email.use || EmailUse.PRIVATE, onChange: function (newUse) { return _this.props.onChange(__assign(__assign({}, email), { use: newUse }), email); } }),
                    !readonly ? (React.createElement("div", { className: "text-right mt-1" },
                        React.createElement("button", { className: "btn btn-link p-0", onClick: function () { return _this.props.onRemove(email); } }, i18next.t("cc.email.control.remove")))) : null))));
    };
    EmailControl.prototype.componentDidMount = function () {
        if (this.props.email.new) {
            this.validate();
        }
    };
    EmailControl.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.email.value !== this.props.email.value) {
            this.validate();
        }
    };
    EmailControl.prototype.validate = function () {
        var _this = this;
        this.validator(function () { return validateEmailSync(_this.props.email); }, function () { return validateEmailAsync(_this.props.email, _this.props.organizationId, _this.props.client, _this.props.userId); }, function (promise, result) {
            _this.props.onChange(__assign(__assign({}, _this.props.email), { validationError: result, validationPromise: promise }), _this.props.email);
        });
    };
    return EmailControl;
}(React.PureComponent));
export { EmailControl };
//# sourceMappingURL=EmailControl.js.map